const OVERLAY_STACK_KEY = '__hammerSystemBarOverlays';

export type SystemBarColors = {
  statusBar: string;
  navigationBar?: string;
};

type SystemBarsWindow = Window & {
  [OVERLAY_STACK_KEY]?: SystemBarColors[];
  webkit?: {
    messageHandlers?: {
      systemBarsBackground?: {
        postMessage: (message: { statusBar: string | null; navigationBar: string | null }) => void;
      };
    };
  };
};

const getSystemBarsWindow = (): SystemBarsWindow | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return window as SystemBarsWindow;
};

const applyTopmost = (systemBarsWindow: SystemBarsWindow): void => {
  const handler = systemBarsWindow.webkit?.messageHandlers?.systemBarsBackground;
  if (!handler) return;

  const stack = systemBarsWindow[OVERLAY_STACK_KEY] ?? [];
  const topmost = stack.length === 0 ? undefined : stack[stack.length - 1];

  handler.postMessage({
    statusBar: topmost?.statusBar ?? null,
    navigationBar: topmost?.navigationBar ?? topmost?.statusBar ?? null,
  });
};

export const pushSystemBarsOverlay = (colors: SystemBarColors): void => {
  const systemBarsWindow = getSystemBarsWindow();
  if (!systemBarsWindow) return;

  systemBarsWindow[OVERLAY_STACK_KEY] = [...(systemBarsWindow[OVERLAY_STACK_KEY] ?? []), colors];
  applyTopmost(systemBarsWindow);
};

export const popSystemBarsOverlay = (): void => {
  const systemBarsWindow = getSystemBarsWindow();
  if (!systemBarsWindow) return;

  systemBarsWindow[OVERLAY_STACK_KEY] = (systemBarsWindow[OVERLAY_STACK_KEY] ?? []).slice(0, -1);
  applyTopmost(systemBarsWindow);
};
